module.exports = __webpack_public_path__ + "9c1b59451194f6dbf7db650a401955e1.ttf";